import { getContext } from "svelte";
export let positionInPaneSymbol = Symbol('positionInPane');
export let stateSymbol = Symbol('state');
export let configurationSymbol = Symbol('configuration');
export let svgTextSizeSymbol = Symbol('svgTextSize');
export let zoomToFitSymbol = Symbol('zoomToFit');
export let getSVGSymbol = Symbol('getSVG');
export function getPositionInPane() {
    return getContext(positionInPaneSymbol);
}
export function getZoomToFit() {
    return getContext(zoomToFitSymbol);
}
export function getState() {
    return getContext(stateSymbol);
}
export function getConfiguration() {
    return getContext(configurationSymbol);
}
export function getSVGTextSize() {
    return getContext(svgTextSizeSymbol);
}
export function getGetSVG() {
    return getContext(getSVGSymbol);
}
